module.exports = __webpack_public_path__ + "static/media/galway.6a33db71.jpg";